import { render, staticRenderFns } from "./bMenu_index.vue?vue&type=template&id=ffdb332a&scoped=true"
import script from "./bMenu_index.vue?vue&type=script&lang=js"
export * from "./bMenu_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdb332a",
  null
  
)

export default component.exports